import { gql } from "apollo-boost";

export const ANALYSIS = gql`
  query Query($text: String!) {
    analysis(text: $text) {
      text
      ents {
        start
        end
        label
        link
      }
      knp {
        tags {
          text
          start
          end
          parent
          children
          featureJson
        }
      }
    }
  }
`;
